const DateTimeReducer = (state, {payload, type}) => {
    switch (type) {
        case 'SET_DATE':
            return {
                ...state,
                date: payload,
                fetching: true,
                time: null,
                member: null
            }
        case 'SET_FREE_TIMES':
            return {
                ...state,
                fetching: false,
                times: payload.times,
                freeTimes: payload.freeTimes,
                members: payload.members,

            }
        case "SET_TIME":
            return {
                ...state,
                time: payload.date,
                member: payload.member
            }
        case "CHANGE_STORE":
            return {
                date: null,
                time: null,
                freeTimes: []
            }
        case "INIT":
            return {
                date: null,
                time: null,
                freeTimes: []
            }
        default:
            return state
    }
};

export default DateTimeReducer;
